exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_object-pie.js
// module id = 47
// module chunks = 1